const IntervalTimer = require('../IntervalTimer');

const Condition = function(instigator, owner, battleState, potency, charges) {
  this.instigator = instigator;
  this.instigatorId = instigator.uid;
  this.owner = owner;
  this.ownerId = owner.uid;
  this.battleState = battleState;
  this.potency = potency;
  this.charges = charges;

  this.expire = () => {
    battleState.expireCondition(this.uid, this.options);
    this.dispose();
  };

  this.initInterval = (callback, interval) => {
    if (this.intervalTimer) {
      this.intervalTimer.pause();
      this.intervalTimer.dispose();
    }

    this.intervalTimer = new IntervalTimer(callback.bind(this), interval);
  };

  this.dispose = () => {

    if (this.intervalTimer) {
      this.intervalTimer.pause();
      this.intervalTimer.dispose();
      this.intervalTimer = null;
    }

    this.instigator = null;
    this.owner = null;
    this.battleState = null;
  };
};
module.exports = Condition;
module.exports.EXPIRED = 'CONDITION_EXPIRED';
